import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { applyAppearance } from './appearance';
import { isNative } from './native';
import './fonts.css';
import './styles.css';

// Theme / prose size / motion from Settings → Appearance, before the first paint.
applyAppearance();

if ('serviceWorker' in navigator) {
  if (isNative()) {
    // Never run the PWA worker inside Capacitor; drop one left by an earlier build.
    void navigator.serviceWorker
      .getRegistrations()
      .then((rs) => Promise.all(rs.map((r) => r.unregister())))
      .then(() => caches.keys())
      .then((ks) => Promise.all(ks.map((k) => caches.delete(k))))
      .catch(() => undefined);
  } else {
    navigator.serviceWorker.addEventListener('message', (e) => {
      // The worker purges caches once per deploy; reload so this page runs the new bundle.
      if ((e.data as { type?: string } | undefined)?.type === 'dt:updated') location.reload();
    });
    void import('virtual:pwa-register').then(({ registerSW }) =>
      registerSW({
        immediate: true,
        // When an updated worker takes control (first load after a deploy), reload once so
        // the page runs the new bundle instead of a stale cached shell.
        onRegisteredSW(_url, registration) {
          if (!registration) return;
          let reloading = false;
          registration.addEventListener('controllerchange', () => {
            if (reloading) return;
            reloading = true;
            location.reload();
          });
        },
      }),
    );
  }
}

const root = document.getElementById('root');
if (!root) throw new Error('missing #root');
createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
